enum ContractEnum {
  MANDATE_CONTRACT = 'MANDATE_CONTRACT',
  WORK_CONTRACT = 'WORK_CONTRACT',
  EMPLOYMENT_TYPE = 'EMPLOYMENT_TYPE',
}

export default ContractEnum
